module.exports = __webpack_public_path__ + "static/media/checkbox.e01df6c0.svg";